import React from "react";
import { Link } from "react-router-dom";

const MainLogin = () => {
  const roles = [
    {
      id: "teacher",
      title: "Teacher",
      icon: "👨‍🏫",
      gradient: "from-blue-500 to-blue-600",
      href: "/login-teacher"
    },
    {
      id: "parent",
      title: "Parent",
      icon: "👨‍👩‍👧‍👦",
      gradient: "from-green-500 to-green-600",
      href: "/login-parent"
    },
    {
      id: "student",
      title: "Student",
      icon: "🎓",
      gradient: "from-purple-500 to-purple-600",
      href: "/student-login"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100 relative overflow-hidden flex flex-col">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none select-none">
        <div className="absolute top-10 left-10 text-6xl">📚</div>
        <div className="absolute top-16 right-20 text-5xl">✏️</div>
        <div className="absolute bottom-20 left-16 text-7xl">🎓</div>
        <div className="absolute bottom-28 right-24 text-6xl">📖</div>
        <div className="absolute top-1/3 left-1/4 text-5xl">🎒</div>
        <div className="absolute top-2/3 right-1/4 text-6xl">🖊️</div>
        <div className="absolute top-1/2 left-1/2 text-5xl">📝</div>
        <div className="absolute top-1/4 right-1/3 text-5xl">🏫</div>
      </div>

      {/* Header */}
      <div className="relative bg-white/10 backdrop-blur-md border-b border-white/20 px-4 py-4">
        <div className="max-w-7xl mx-auto flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
            <span className="text-white text-xl">🏫</span>
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-800 leading-tight">ClassHero</h1>
            <p className="text-xs text-gray-600">School Portal</p>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="relative flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          {/* Welcome text */}
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-800">Welcome back!</h2>
            <p className="text-gray-600 mt-1 text-sm">Select your role to sign in</p>
          </div>

          {/* Role cards */}
          <div className="bg-white/30 backdrop-blur-md rounded-2xl shadow-lg border border-white/40 p-6 sm:p-8">
            <div className="grid grid-cols-3 gap-x-4 gap-y-6 justify-items-center">
              {roles.map((role) => (
                <a
                  key={role.id}
                  href={role.href}
                  className="group flex flex-col items-center"
                >
                  <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br ${role.gradient} flex items-center justify-center shadow-lg group-hover:shadow-xl group-active:scale-95 transition-all duration-200`}>
                    <span className="text-3xl sm:text-4xl">{role.icon}</span>
                  </div>
                  <p className="mt-2 text-xs font-semibold text-gray-700 text-center group-hover:text-gray-900 transition-colors">
                    {role.title}
                  </p>
                </a>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 text-center">
            <Link to="/privacy-policy" className="text-xs text-gray-500 hover:text-gray-700 transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLogin;
